export default "__VITE_ASSET__d7b9fc56__"